import type { PropsWithChildren } from "react";
import { useTranslation } from "react-i18next";
import { type Lenke, LenkerContainer } from "@/components/LenkerContainer";
import { cn } from "@/utils";

export function NyttigeLenkerList({
  className,
  isFaqPage = false,
}: PropsWithChildren<{ className?: string; isFaqPage?: boolean }>) {
  const { t } = useTranslation();

  const nyttigeLenker: Lenke[] = [
    {
      text: t("eksterneLenker.forskriftOmNorgespris.label"),
      href: t("eksterneLenker.forskriftOmNorgespris.url"),
    },
    {
      text: t("eksterneLenker.lovOmNorgespris.label"),
      href: t("eksterneLenker.lovOmNorgespris.url"),
    },
  ];
  if (!isFaqPage) {
    nyttigeLenker.push({
      text: t("eksterneLenker.kundestotte.label"),
      href: t("eksterneLenker.kundestotte.url"),
      external: false,
    });
  }
  /*
  nyttigeLenker.push({
    text: t("eksterneLenker.avtalevilkaar.label"),
    href: t("eksterneLenker.avtalevilkaar.url"),
    external: false,
  });
  */

  return (
    <LenkerContainer
      title={t("components.nyttige-lenker")}
      links={nyttigeLenker}
      className={cn("lg:max-w-sm w-fit", className)}
      variant="default"
    />
  );
}
